module.exports = __webpack_public_path__ + "static/img/104.416b64d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/104.jpeg
// module id = Hi4V
// module chunks = 1